import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/node_modules/next/font/local/target.css?{\"path\":\"node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/var/www/stms/FrontEnd/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/stms/FrontEnd/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/var/www/stms/FrontEnd/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/stms/FrontEnd/src/contexts/authContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfirmDialogProvider"] */ "/var/www/stms/FrontEnd/src/providers/confirmDialogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoaderProvider"] */ "/var/www/stms/FrontEnd/src/providers/loaderProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/var/www/stms/FrontEnd/src/providers/theme-provider.tsx");
